import { withDisplayName } from '@hocs/with-display-name'
import { SEO_IDS } from '@meta/constants'
import { TwitterCard } from '@typings/seo'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulSiteSeo: Utils.EntryFC<Queries.ContentfulSiteSeoFragment> = ({
  content: {
    facebookAdminsId,
    ogSiteName,
    twitterSite,
    twitterSiteId,
    twitterCreator,
    twitterCreatorId,
    googleSiteVerification,
  },
}) => (
  <>
    <html id={SEO_IDS.LANG} lang="fr" />
    <meta content="fr_FR" id={SEO_IDS.OG_LOCALE} property="og:locale" />
    <meta
      content={ogSiteName}
      id={SEO_IDS.OG_SITENAME}
      property="og:site_name"
    />
    <meta
      content={TwitterCard.Summary}
      id={SEO_IDS.TWITTER_CARD}
      property="twitter:card"
    />
    <meta
      content={twitterSite}
      id={SEO_IDS.TWITTER_SITE}
      property="twitter:site"
    />
    <meta
      content={twitterSiteId}
      id={SEO_IDS.TWITTER_SITE_ID}
      name="twitter:site:id"
    />
    <meta
      content={twitterCreator}
      id={SEO_IDS.TWITTER_CREATOR}
      property="twitter:creator"
    />
    <meta
      content={twitterCreatorId}
      id={SEO_IDS.TWITTER_CREATOR_ID}
      property="twitter:creator:id"
    />
    <meta
      content={facebookAdminsId}
      id={SEO_IDS.FB_ADMINS_ID}
      property="fb:admins"
    />
    {googleSiteVerification && (
      <meta
        content={googleSiteVerification}
        id={SEO_IDS.GOOGLE_SITE_VERIFICATION}
        // don't rename to property, it's not a valid attribute for google search console
        name="google-site-verification"
      />
    )}
  </>
)

export const query = graphql`
  fragment ContentfulSiteSeo on ContentfulSite {
    ...ContentfulEntry
    googleSiteVerification
    twitterSite
    twitterSiteId
    twitterCreator
    twitterCreatorId
    facebookAdminsId
    ogSiteName
  }
`

export default withDisplayName(ContentfulSiteSeo, 'ContentfulSiteSeo')
